
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { IServiceMap } from '@/business/BusinessFormData'
import { IFileList, IOrderForm } from '@/types/placeOrderTypes'
import OrderContentProcess from '../imageContentProcess.vue'
import { ServiceContentEnum } from '@/business/ServiceContent'
import ZipUpload from './ZipUpload.vue'
import PdfUpload from './PdfUpload.vue'
import WordUpload from './WordUpload.vue'
import JsonUpload from './JsonUpload.vue'
import ImageUpload from './ImageUpload.vue'
import { FileProcessor } from './fileOperations'

@Component({
  components: {
    OrderContentProcess,
    ZipUpload,
    PdfUpload,
    WordUpload,
    JsonUpload,
    // ImageUpload,
  },
})
export default class UploadMaterial extends Vue {
  @Prop() form!: IOrderForm
  @Prop() screenForm!: Function
  @Prop() checkForm!: Function
  @Prop({}) formInfo!: IServiceMap
  @Prop({}) type!: string

  @Action('setUploading') setUploading: any
  @Getter('uploading') uploading: any
  @Action('setOrderId') setOrderId: any
  @Getter('order_id') order_id: any
  @Getter('user') user: any

  files: IFileList[] = []
  activeNames: string[] = []
  zipList: IFileList[] = []
  pdfList: IFileList[] = []
  wordList: IFileList[] = []
  jsonList: IFileList[] = []
  imgList: IFileList[] = []
  checking = false
  fileType: '' | number = ''

  get isPpt2Seewo() {
    return this.formInfo.formData.service_content === ServiceContentEnum.PptToEnbx
  }

  @Watch('files')
  async onFbdFilesChange() {
    this.checking = true

    try {
      // 使用FileProcessor工具类处理文件
      const result = await FileProcessor.processFiles(this.files, {
        serviceContent: this.formInfo.formData.service_content,
        activeNames: this.activeNames,
        isPpt2Seewo: this.isPpt2Seewo,
      })

      this.activeNames = result.activeNames
    } catch (error) {
      console.error('处理文件时出错', error)
    } finally {
      this.checking = false
    }
  }

  get ServiceContentEnum() {
    return ServiceContentEnum
  }

  get WordToFbd() {
    return this.formInfo.formData.service_content === 11 || this.formInfo.formData.service_content === 16
  }

  get WordToPpt() {
    return this.formInfo.formData.service_content === 18
  }

  get JsonToPpt () {
    if (!this.formInfo || !this.formInfo.formData) {
      console.error('formInfo或formData未定义');
      return false;
    }

    const result = this.formInfo.formData.service_content === 19;
    return result;
  }

  async mounted() {
    if (this.formInfo.mode === 'selected') {
      this.fileType = 0
      if (this.WordToFbd || this.WordToPpt) this.fileType = 1
      if (this.JsonToPpt) this.fileType = 4;
    }
    if (this.form.material.type === 0) this.fileType = 0
    else if (this.form.material.type === 1) this.fileType = 1
    this.handleFileTypeChange()

    await this.init()
  }

  init() {
    this.pdfList = this.form.material.oss_pdf_files.map(item => {
      return {
        pdf: { name: item.name },
        status: 'upload-success',
      }
    })
    this.wordList = this.form.material.oss_word_files!.map(item => {
      return {
        word: { name: item.name },
        status: 'upload-success',
      }
    })
    if(this.form.material.oss_zip_files.length > 0){
      this.zipList = this.form.material.oss_zip_files.map(item => {
        return {
          zip: { name: item.name },
          status: 'upload-success',
        }
      })
    }else {
      this.zipList = this.form.material.oss_fbd_zips.map(item => {
        return {
          zip: { name: item.name },
          fbdList: item.fbd_info,
          status: 'upload-success',
        }
      })
    }
  }

  togglePdfType() {
    this.pdfList.forEach(item => {
      item.type = item.type === 'body' ? 'answer' : 'body'
    })
    this.$message.success('切换 PDF 正文答案成功!')
  }

  handleFileTypeChange() {
    this.$emit('type-change', this.fileType)
  }

  get hasUploadedFiles () {
    return this.zipList.length > 0 || this.wordList.length > 0 || this.jsonList.length > 0;
  }
}
